import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import {URI} from '../../Conexiones/Conexion';
import { getToken } from '../../Conexiones/Conexion';

const AgregarGasto = () => {

    const [concepto,setConcepto] = useState()
    const [unidad,setUnidad] = useState()
    const [cantidad,setCantidad] = useState()
    const [precio,setPrecio] = useState()
    const [fecha,setFecha] = useState()
    const [gastOfi,setGasOfi] = useState([])
    const navigate = useNavigate()

    useEffect( ()=>{
        const getAdicionales = async () =>{
            const res = await axios.get(URI + 'adicionales/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setGasOfi(res.data)
        }
        getAdicionales()
    },[navigate])
    

    const confirmar = async () =>{
        Swal.fire({
            title: '¿ESTAS SEGURO DE REGISTRAR ESTE GASTO?',
            icon: 'warning',
            iconColor:'#1e2c4f',
            color: '#1e2c4f',
            showCancelButton: true,
            confirmButtonColor: '#1e2c4f',
            cancelButtonColor: '#d33',
            confirmButtonText: 'SÍ, REGISTRAR',
            cancelButtonText: 'CANCELAR'
        }).then(async (result) => {        
            if (result.isConfirmed) {
                if(unidad.trim().length === 0){
                    Swal.fire({
                        title: 'CAMPOS VACIOS',
                        icon: 'warning',
                        iconColor:'#1e2c4f',
                        color: '#1e2c4f',
                        text: 'EL CAMPO UNIDAD ESTA VACIO',
                        confirmButtonColor: '#1e2c4f',
                        confirmButtonText: 'ACEPTAR',
                    })
                }else{
                    const idAd = parseInt(concepto)
                    const cant = parseInt(cantidad)
                    const price = parseFloat(precio)
                    await axios.post(URI+'guardarGastosOficina',{
                    idGasto:idAd, unidad:unidad, cantidad:cant, precio:price, fecha:fecha}).then(
                    res => {
                        if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                            Swal.fire(
                                'Falla en el servidor...',
                                'Intente más tarde',
                                'question'
                                )
                        }else{
                            if(res.data.message==="SE GUARDÓ EL REGISTRO CORRECTAMENTE"){
                                Swal.fire({
                                    icon: 'success',
                                    title: res.data.message,
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        navigate('/inicio/Oficina/GastosOficina')
                                        window.location.reload();
                                    } 
                                })
                            }else{
                                Swal.fire({
                                    title: '¡ERROR!',
                                    text: res.data.message,                 
                                    icon: 'error',
                                    confirmButtonColor: 'red',
                                    allowOutsideClick: false,
                                    confirmButtonText: 'ACEPTAR'
                                })
                            }
                        }
                    }
                    ).catch(
                        err => {
                            if(err.message === "Network Error"){
                                Swal.fire(
                                    'Falla en el servidor...',
                                    'Intente más tarde',
                                    'question'
                                )
                            }else{
                                Swal.fire(
                                    'Falla en el servidor...',
                                    err.message,
                                    'question'
                                )
                            }
                        }
                    )
                }
            }
        })
    }

    const validar = async () =>{
        Swal.fire({
            title: 'CAMPOS VACIOS',
            icon: 'warning',
            iconColor:'#1e2c4f',
            color: '#1e2c4f',
            text: 'POR FAVOR RELLENE LOS CAMPOS QUE FALTAN',
            confirmButtonColor: '#1e2c4f',
            confirmButtonText: 'ACEPTAR',
        })
    }

    return (
        <div>            
            <div className="modal fade" id="modal-gasto-oficina" data-bs-backdrop="static"  tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title " id="exampleModalLabel">REGISTRAR GASTO DE OFICINA</h5>
                            <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form >
                        <div className="divO">
                            <label className="obligatorio">Obligatorio *</label>  
                        </div>
                        <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CONCEPTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <select className="form-control" required 
                                onChange={e => setConcepto(e.target.value) }   >
                                    <option >--Seleccione una opción--</option>
                                    {gastOfi.map(a => {
                                        return(
                                            <option key={a.idAdicional} value={a.idAdicional}>{a.nombreAdicional}</option>
                                        )
                                    })
                                    }                                
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CANTIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number" min={0} className="form-control"  id="exampleFormControlInput1" required
                                onChange={e => setCantidad(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">PRECIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number"  min={0} className="form-control"  id="exampleFormControlInput2" step="any" required
                                onChange={e => setPrecio(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">UNIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="text"  min={0} className="form-control"  id="exampleFormControlInput2" step="any" required
                                onChange={e => setUnidad(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="date" className="form-control"  id="exampleFormControlInput1" required
                                onChange={e => setFecha(e.target.value) }/>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center foot" >
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" >CANCELAR</button>
                            {concepto === undefined | concepto === '' | 
                            cantidad === undefined | cantidad === '' | 
                            unidad === undefined | unidad === '' |
                            precio === undefined | precio === '' |
                            fecha === undefined | fecha === '' ? (
                                <button type="button" className="btn btncolor" onClick={validar} >ACEPTAR</button>
                            ):(
                                <button type="button" className="btn btncolor" onClick={confirmar} >ACEPTAR</button>
                            )}
                                
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgregarGasto;